export type ApiClientScope = 'records:read' | 'records:write';

export type ApiClientStatus = 'active' | 'revoked';

export class ApiClient {
  id?: string;
  name?: string;
  keyPrefix?: string;
  apiKey?: string;
  scopes?: ApiClientScope[];
  status?:  ApiClientStatus;
  createdBy?: string;
  expiresAt?: Date;
  lastUsedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}